import script from "./LinkView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkView.vue?vue&type=script&setup=true&lang=ts"

import "./LinkView.vue?vue&type=style&index=0&id=05c83882&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c83882"]])

export default __exports__